import "core-js/modules/es.array.map.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from 'components/Heading';
import InlineList from 'components/InlineList';
import Stack from 'components/Stack';
import Text from 'components/Text';
import Landmark from 'components/Landmark';
import MeetingItem from './MeetingItem';
function MeetingSection(_ref) {
  var _ref$userMeetings = _ref.userMeetings,
    userMeetings = _ref$userMeetings === void 0 ? [] : _ref$userMeetings,
    getLocation = _ref.getLocation;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("section", {
    "aria-labelledby": "meetings-this-week-heading"
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h3",
    size: "small",
    mb: "s",
    id: "meetings-this-week-heading"
  }, t('skills_title_meetings_this_week')), (userMeetings === null || userMeetings === void 0 ? void 0 : userMeetings.length) === 0 ? /*#__PURE__*/React.createElement(Landmark, {
    height: 100
  }, /*#__PURE__*/React.createElement(Text, {
    dimmed: true
  }, t('amount_none'))) : /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs",
    as: "list"
  }, userMeetings.map(function (meeting) {
    var startTime = new Date(meeting.startTime);
    var formattedDate = startTime.toLocaleDateString('en-GB', {
      dateStyle: 'medium'
    });
    var formattedTime = startTime.toLocaleTimeString('en-GB', {
      timeStyle: 'short',
      hour12: true
    });
    return /*#__PURE__*/React.createElement(MeetingItem, {
      key: meeting.meetingId,
      score: meeting.score,
      subtitle: /*#__PURE__*/React.createElement(InlineList, {
        splitBy: "dot",
        as: "p",
        itemAs: "span",
        display: "inline"
      }, formattedDate, formattedTime),
      title: meeting.title || '',
      link: getLocation({
        meetingId: meeting.meetingId
      })
    });
  })));
}
export default MeetingSection;